"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8094],{

/***/ 93343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var _hooks_useDelayedUnmount__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64539);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34701);
/* harmony import */ var _hooks_useOnClickOutside__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93788);
/* harmony import */ var _util_getPortalRoot__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70032);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44147);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89663);
/* harmony import */ var _Overlay__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72881);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81641);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86258);












var BottomDrawer = function BottomDrawer(param) {
    var content = param.content, isOpen = param.isOpen, setIsOpen = param.setIsOpen;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var shouldRender = (0,_hooks_useDelayedUnmount__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(isOpen, 350);
    var isMobile = (0,_contexts__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().isMobile;
    (0,_hooks_useOnClickOutside__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ref === null || ref === void 0 ? void 0 : ref.current, (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return setIsOpen(false);
    }, [
        setIsOpen
    ]));
    if (!shouldRender || !isMobile) {
        return null;
    }
    var portal = (0,_util_getPortalRoot__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    if (portal) return /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Overlay__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                isUnmounting: !isOpen
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_8__/* .DrawerContainer */ .qt, {
                ref: ref,
                isUnmounting: !isOpen,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        position: "absolute",
                        right: "16px",
                        top: "0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            variant: "text",
                            onClick: function onClick() {
                                return setIsOpen(false);
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                color: "#fff"
                            })
                        })
                    }),
                    content
                ]
            })
        ]
    }), portal);
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (BottomDrawer);


/***/ }),

/***/ 37303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.29006 15.88L13.1701 12L9.29006 8.12001C8.90006 7.73001 8.90006 7.10001 9.29006 6.71001C9.68006 6.32001 10.3101 6.32001 10.7001 6.71001L15.2901 11.3C15.6801 11.69 15.6801 12.32 15.2901 12.71L10.7001 17.3C10.3101 17.69 9.68006 17.69 9.29006 17.3C8.91006 16.91 8.90006 16.27 9.29006 15.88Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 70112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 25 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M20.497 4.6l-.004-.028-.006-.036-.008-.033-.007-.03-.012-.032-.01-.03-.014-.028-.014-.03-.016-.027-.018-.03-.021-.028-.018-.024a.663.663 0 00-.044-.048v-.001a.66.66 0 00-.049-.044l-.024-.018-.028-.02-.03-.018-.026-.016-.03-.015c-.01-.004-.02-.01-.03-.013l-.03-.011-.03-.011-.031-.008-.033-.008-.035-.005-.03-.005A.684.684 0 0019.834 4h-4.667a.667.667 0 100 1.333h3.057l-4.862 4.862a.667.667 0 10.943.943l4.862-4.862v3.057a.667.667 0 101.333 0V4.667a.658.658 0 00-.003-.066zM10.696 12.861l-4.862 4.862v-3.057a.667.667 0 10-1.333 0v4.667l.003.066.005.029.005.035.008.033.008.03.01.032.012.03.013.029.015.03.016.027.017.029.021.028.018.024a.663.663 0 00.093.093l.024.018.029.021.029.018.026.016.03.014.03.014.03.01.031.012.03.007.033.008.036.006.029.004a.657.657 0 00.066.003h4.666a.667.667 0 000-1.333H6.777l4.862-4.862a.667.667 0 00-.943-.943z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 68187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 25 25"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12.327 13.27c0-.01-.003-.019-.004-.028l-.005-.036-.009-.033-.007-.03-.011-.032-.011-.03-.014-.028-.014-.03c-.005-.01-.01-.019-.016-.027l-.018-.03-.021-.028-.018-.024a.692.692 0 00-.044-.049.674.674 0 00-.049-.044l-.024-.018-.028-.02-.03-.018-.026-.016-.03-.015c-.01-.005-.02-.01-.03-.013l-.03-.011-.03-.011-.031-.008-.033-.008-.035-.006-.03-.004a.689.689 0 00-.065-.003H6.997a.667.667 0 000 1.333h3.057l-4.862 4.862a.667.667 0 10.943.943l4.862-4.862v3.057a.667.667 0 001.333 0v-4.666a.689.689 0 00-.003-.066zM19.862 4.195L15 9.057V6a.667.667 0 10-1.333 0v4.667c0 .022.001.044.003.065l.005.03.005.035.008.033.008.03.01.032.012.03.013.029.015.03.016.027.017.029.021.028.018.024a.692.692 0 00.093.093l.024.018.028.021.03.018.027.015.03.015.029.014.03.01.031.012.03.007.033.008.036.006.029.004a.688.688 0 00.066.003H19A.667.667 0 0019 10h-3.057l4.862-4.862a.667.667 0 00-.943-.943z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 20363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 25"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.86 4.86003L21.65 7.65003C21.84 7.84003 21.84 8.16003 21.64 8.35003L18.85 11.14C18.54 11.46 18 11.24 18 10.79V9.00003H4C3.45 9.00003 3 8.55003 3 8.00003C3 7.45003 3.45 7.00003 4 7.00003H18V5.21003C18 4.76003 18.54 4.54003 18.86 4.86003ZM5.14001 19.14L2.35001 16.35C2.16001 16.16 2.16001 15.84 2.36001 15.65L5.15001 12.86C5.46001 12.54 6.00001 12.76 6.00001 13.21V15H20C20.55 15 21 15.45 21 16C21 16.55 20.55 17 20 17H6.00001V18.79C6.00001 19.24 5.46001 19.46 5.14001 19.14Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 64539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Use this hook when you want to animate something when it appears on the screen (e.g. when some prop set to true)
 * but when its not on the screen you want it to be fully unmounted and not just hidden or height 0.
 * This is especially useful when you have a table of 100s rows and each row has expandable element that appears on click.
 * If you just set the expanding animation while keeping inactive elements mounted all those 100 elements will load the DOM,
 * and if they all receive updates via props you're looking at 100 DOM updates for hidden elements.
 * This hook "shows" element immediately when the isMounted is true
 * but keeps element mounted for delayTime to let unmounting animation happen, after which you unmount element completely.
 * delayTime should be the same as animation time in most cases.
 */ var useDelayedUnmount = function useDelayedUnmount(isMounted, delayTime) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), shouldRender = ref[0], setShouldRender = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var timeoutId;
        if (isMounted && !shouldRender) {
            setShouldRender(true);
        } else if (!isMounted && shouldRender) {
            timeoutId = setTimeout(function() {
                return setShouldRender(false);
            }, delayTime);
        }
        return function() {
            return clearTimeout(timeoutId);
        };
    }, [
        isMounted,
        delayTime,
        shouldRender
    ]);
    return shouldRender;
};
/* harmony default export */ __webpack_exports__["Z"] = (useDelayedUnmount);


/***/ }),

/***/ 93788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useOnClickOutside = function useOnClickOutside(htmlNode, handler) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (htmlNode) {
            var listener = function listener(event) {
                // Do nothing if clicking ref's element or descendent elements
                if (htmlNode.contains(event.target)) {
                    return;
                }
                handler(event);
            };
            document.addEventListener("mousedown", listener);
            document.addEventListener("touchstart", listener);
            return function() {
                document.removeEventListener("mousedown", listener);
                document.removeEventListener("touchstart", listener);
            };
        }
        return undefined;
    }, // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [
        htmlNode,
        handler
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useOnClickOutside);


/***/ }),

/***/ 7216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85937);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44147);
/* harmony import */ var components_SearchModal_ImportToken__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97139);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68486);




var ImportTokenWarningModal = function(param) {
    var tokens = param.tokens, onDismiss = param.onDismiss, onCancel = param.onCancel;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        title: t("Import Token"),
        onDismiss: function() {
            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
            onCancel();
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            maxWidth: "380px",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SearchModal_ImportToken__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                tokens: tokens,
                handleCurrencySelect: onDismiss
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImportTokenWarningModal);


/***/ }),

/***/ 74156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(186);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12587);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51983);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40735);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98553);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(44976);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(63970);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68486);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42918);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: ",
        ";\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  align-items: center;\n  padding-top: 16px;\n  padding-right: ",
        ";\n  ",
        " {\n    justify-content: space-between;\n    flex-direction: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  svg {\n    fill: ",
        ";\n    transition: background-color 0.2s, opacity 0.2s;\n  }\n  &:hover {\n    svg {\n      opacity: 0.65;\n    }\n  }\n  &:active {\n    svg {\n      opacity: 0.85;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var Wrapper = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-28474ca1-0"
})(_templateObject(), function(param) {
    var $isSide = param.$isSide;
    return $isSide ? "100%" : "auto";
}, function(param) {
    var $isSide = param.$isSide;
    return $isSide ? "32px" : "0px";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var $isSide = param.$isSide;
    return $isSide ? "column" : "row";
}));
var BubbleWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-28474ca1-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var Footer = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, _helpUrl = param.helpUrl, helpUrl = _helpUrl === void 0 ? config_constants__WEBPACK_IMPORTED_MODULE_4__/* .EXCHANGE_DOCS_URLS */ .SO : _helpUrl;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var isSide = variant === "side";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        $isSide: isSide,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                flexDirection: isSide ? "column" : [
                    "column",
                    "column",
                    "row"
                ],
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        variant: "subtle",
                        scale: "sm",
                        activeIndex: 0,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                children: "V2"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                as: "a",
                                href: "https://v1exchange.pancakeswap.finance/#/",
                                children: t("V1 (old)")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        id: "ercBridge",
                        href: "https://docs.binance.org/smart-chain/guides/cross-chain.html",
                        ml: [
                            0,
                            0,
                            "40px"
                        ],
                        mt: [
                            "20px",
                            "20px",
                            isSide ? "20px" : 0
                        ],
                        mb: [
                            "8px",
                            "8px",
                            0
                        ],
                        children: t("Convert ERC-20 to BEP-20")
                    })
                ]
            }),
            isSide && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                flexGrow: 1
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                flexGrow: isSide ? 0 : 1,
                alignItems: "center",
                width: [
                    "100%",
                    "100%",
                    "100%",
                    isSide ? "100%" : "auto"
                ],
                justifyContent: [
                    "center",
                    "center",
                    "center",
                    "flex-end"
                ],
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(BubbleWrapper, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                id: "clickExchangeHelp",
                                as: "a",
                                external: true,
                                href: helpUrl,
                                variant: "subtle",
                                children: t("Need help ?")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                viewBox: "0 0 16 16",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                    d: "M0 16V0C0 0 3 1 6 1C9 1 16 -2 16 3.5C16 10.5 7.5 16 0 16Z"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        src: "/images/help.png",
                        alt: "Get some help",
                        width: 160,
                        height: 108
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(Footer));


/***/ }),

/***/ 78147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62077);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62685);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(186);
/* harmony import */ var utils_formatInfoNumbers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59604);
/* harmony import */ var _Layout_Flex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44142);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 32px;\n  line-height: 1.1;\n\n  ",
        " {\n    font-size: 40px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var formatOptions = {
    notation: "standard",
    displayThreshold: 0.001,
    tokenPrecision: true
};
var TextLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d4f6fb8c-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var PairPriceDisplay = function(_param) {
    var value = _param.value, inputSymbol = _param.inputSymbol, outputSymbol = _param.outputSymbol, children = _param.children, _format = _param.format, format = _format === void 0 ? true : _format, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "value",
        "inputSymbol",
        "outputSymbol",
        "children",
        "format"
    ]);
    return value ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Flex__WEBPACK_IMPORTED_MODULE_3__/* .FlexGap */ .O, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        alignItems: "baseline"
    }, props), {
        mt: -4,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                alignItems: "inherit",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TextLabel, {
                        mr: "8px",
                        bold: true,
                        children: format ? (0,utils_formatInfoNumbers__WEBPACK_IMPORTED_MODULE_2__/* .formatAmount */ .d)(typeof value === "string" ? parseFloat(value) : value, formatOptions) : value
                    }),
                    inputSymbol && outputSymbol && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        color: "textSubtle",
                        fontSize: "20px",
                        bold: true,
                        lineHeight: 1.1,
                        children: "".concat(inputSymbol, "/").concat(outputSymbol)
                    })
                ]
            }),
            children
        ]
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        height: "36px",
        width: "128px"
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (PairPriceDisplay);


/***/ }),

/***/ 32600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D0": function() { return /* binding */ useOrderActionHandlers; },
/* harmony export */   "b": function() { return /* binding */ useDerivedOrderInfo; },
/* harmony export */   "hH": function() { return /* binding */ useOrderState; },
/* harmony export */   "jj": function() { return /* binding */ useDefaultsFromURLSearch; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(14924);
/* harmony import */ var jsbi__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39499);
/* harmony import */ var jsbi__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jsbi__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46472);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56974);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97477);
/* harmony import */ var utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73938);
/* harmony import */ var hooks_Tokens__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41166);
/* harmony import */ var hooks_Trades__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94293);
/* harmony import */ var views_LimitOrders_utils_getPriceForOneToken__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13629);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97119);
/* harmony import */ var _pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68492);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68486);
/* harmony import */ var _wallet_hooks__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5460);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47330);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(91392);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(3760);



















// Get desired input amount in output basis mode
var getDesiredInput = function(outputValue, exchangeRate, inputCurrency, outputCurrency, isInverted) {
    if (!outputValue || !inputCurrency || !outputCurrency) {
        return undefined;
    }
    var parsedOutAmount = (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(outputValue, isInverted ? inputCurrency : outputCurrency);
    var parsedExchangeRate = (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(exchangeRate, isInverted ? inputCurrency : outputCurrency);
    if (!parsedOutAmount || !parsedExchangeRate) {
        return undefined;
    }
    if (isInverted) {
        var invertedResultAsFraction = parsedOutAmount.multiply(parsedExchangeRate.asFraction).multiply(jsbi__WEBPACK_IMPORTED_MODULE_0___default().exponentiate(config_constants_exchange__WEBPACK_IMPORTED_MODULE_4__/* .BIG_INT_TEN */ .TY, jsbi__WEBPACK_IMPORTED_MODULE_0___default().BigInt(inputCurrency.decimals)));
        var invertedResultAsAmount = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(inputCurrency, invertedResultAsFraction.toFixed(0));
        return invertedResultAsAmount;
    }
    var resultAsFraction = parsedOutAmount.divide(parsedExchangeRate.asFraction).multiply(jsbi__WEBPACK_IMPORTED_MODULE_0___default().exponentiate(config_constants_exchange__WEBPACK_IMPORTED_MODULE_4__/* .BIG_INT_TEN */ .TY, jsbi__WEBPACK_IMPORTED_MODULE_0___default().BigInt(inputCurrency.decimals)));
    return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(inputCurrency, resultAsFraction.quotient.toString());
};
// Get desired output amount in input basis mode
var getDesiredOutput = function(inputValue, exchangeRate, inputCurrency, outputCurrency, isInverted) {
    if (!inputValue || !inputCurrency || !outputCurrency) {
        return undefined;
    }
    var parsedInputAmount = (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(inputValue, isInverted ? outputCurrency : inputCurrency);
    var parsedExchangeRate = (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(exchangeRate, isInverted ? inputCurrency : outputCurrency);
    if (!parsedExchangeRate || !parsedInputAmount) {
        return undefined;
    }
    if (isInverted) {
        var invertedResultAsFraction = parsedInputAmount.multiply(jsbi__WEBPACK_IMPORTED_MODULE_0___default().exponentiate(config_constants_exchange__WEBPACK_IMPORTED_MODULE_4__/* .BIG_INT_TEN */ .TY, jsbi__WEBPACK_IMPORTED_MODULE_0___default().BigInt(inputCurrency.decimals))).divide(parsedExchangeRate.asFraction);
        return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(outputCurrency, invertedResultAsFraction.quotient);
    }
    var resultAsFraction = parsedInputAmount.divide(jsbi__WEBPACK_IMPORTED_MODULE_0___default().exponentiate(config_constants_exchange__WEBPACK_IMPORTED_MODULE_4__/* .BIG_INT_TEN */ .TY, jsbi__WEBPACK_IMPORTED_MODULE_0___default().BigInt(inputCurrency.decimals))).multiply(parsedExchangeRate.asFraction);
    return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(outputCurrency, resultAsFraction.quotient.toString());
};
// Just returns Redux state for limitOrders
var useOrderState = function() {
    return (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.limitOrders;
    });
};
// Returns handlers to change user-defined parts of limitOrders state
var useOrderActionHandlers = function() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var onCurrencySelection = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(field, currency) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_15__/* .selectCurrency */ .j)({
            field: field,
            currencyId: currency.isToken ? currency.address : currency.isNative ? "BNB" : ""
        }));
    }, [
        dispatch
    ]);
    var onSwitchTokens = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_15__/* .switchCurrencies */ .KS)());
    }, [
        dispatch
    ]);
    var onUserInput = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(field, typedValue) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_15__/* .typeInput */ .LC)({
            field: field,
            typedValue: typedValue
        }));
    }, [
        dispatch
    ]);
    var onChangeRateType = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(rateType) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_15__/* .setRateType */ .sN)({
            rateType: rateType
        }));
    }, [
        dispatch
    ]);
    return {
        onSwitchTokens: onSwitchTokens,
        onCurrencySelection: onCurrencySelection,
        onUserInput: onUserInput,
        onChangeRateType: onChangeRateType
    };
};
var getErrorMessage = function(account, wrappedCurrencies, currencies, currencyBalances, parsedAmounts, trade, price, rateType, t) {
    if (!account) {
        return t("Connect Wallet");
    }
    if (wrappedCurrencies.input && wrappedCurrencies.output && wrappedCurrencies.input.address.toLowerCase() === wrappedCurrencies.output.address.toLowerCase()) {
        return t("Order not allowed");
    }
    var hasBothTokensSelected = currencies.input && currencies.output;
    if (!hasBothTokensSelected) {
        return t("Select a token");
    }
    var hasAtLeastOneParsedAmount = parsedAmounts.input || parsedAmounts.output;
    var tradeIsNotAvailable = !trade || !(trade === null || trade === void 0 ? void 0 : trade.route);
    if (hasAtLeastOneParsedAmount && tradeIsNotAvailable) {
        return t("Insufficient liquidity for this trade.");
    }
    var someParsedAmountIsMissing = !parsedAmounts.input || !parsedAmounts.output;
    if (someParsedAmountIsMissing) {
        return t("Enter an amount");
    }
    if (currencyBalances.input && currencyBalances.input.lessThan(parsedAmounts.input)) {
        return t("Insufficient %symbol% balance", {
            symbol: currencyBalances.input.currency.symbol
        });
    }
    if (price) {
        if (rateType === _types__WEBPACK_IMPORTED_MODULE_16__/* .Rate.MUL */ .j.MUL && (price.lessThan(trade.executionPrice.asFraction) || price.equalTo(trade.executionPrice.asFraction))) {
            return t("Only possible to place sell orders above market rate");
        }
        if (rateType === _types__WEBPACK_IMPORTED_MODULE_16__/* .Rate.DIV */ .j.DIV && (price.invert().greaterThan(trade.executionPrice.invert().asFraction) || price.invert().equalTo(trade.executionPrice.invert().asFraction))) {
            return t("Only possible to place buy orders below market rate");
        }
    }
    return undefined;
};
// from the current swap inputs, compute the best trade and return it.
var useDerivedOrderInfo = function() {
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), account = ref5.account, chainId = ref5.chainId;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_13__/* .useTranslation */ .$G)().t;
    var ref6 = useOrderState(), independentField = ref6.independentField, basisField = ref6.basisField, typedValue = ref6.typedValue, _INPUT = ref6[_types__WEBPACK_IMPORTED_MODULE_16__/* .Field.INPUT */ .g.INPUT], inputCurrencyId = _INPUT.currencyId, _OUTPUT = ref6[_types__WEBPACK_IMPORTED_MODULE_16__/* .Field.OUTPUT */ .g.OUTPUT], outputCurrencyId = _OUTPUT.currencyId, rateType = ref6.rateType, inputValue = ref6.inputValue, outputValue = ref6.outputValue;
    // Get Currency objects based on currencyId strings
    var inputCurrency = (0,hooks_Tokens__WEBPACK_IMPORTED_MODULE_8__/* .useCurrency */ .U8)(inputCurrencyId);
    var outputCurrency = (0,hooks_Tokens__WEBPACK_IMPORTED_MODULE_8__/* .useCurrency */ .U8)(outputCurrencyId);
    var currencies = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return {
            input: inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined,
            output: outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined
        };
    }, [
        inputCurrency,
        outputCurrency
    ]);
    var wrappedCurrencies = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return {
            input: (0,utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_7__/* .wrappedCurrency */ .pu)(currencies.input, chainId),
            output: (0,utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_7__/* .wrappedCurrency */ .pu)(currencies.output, chainId)
        };
    }, [
        currencies.input,
        currencies.output,
        chainId
    ]);
    // Get user balance for selected Currencies
    var relevantTokenBalances = (0,_wallet_hooks__WEBPACK_IMPORTED_MODULE_14__/* .useCurrencyBalances */ .K5)(account !== null && account !== void 0 ? account : undefined, [
        inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined,
        outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined, 
    ]);
    var currencyBalances = {
        input: relevantTokenBalances[0],
        output: relevantTokenBalances[1]
    };
    // Get CurrencyAmount for the inputCurrency amount specified by user
    var inputAmount = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(inputValue, inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined);
    }, [
        inputValue,
        inputCurrency
    ]);
    // Get CurrencyAmount for the outputCurrency amount specified by user
    var outputAmount = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(outputValue, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined);
    }, [
        outputValue,
        outputCurrency
    ]);
    // Whether user modified the INPUT field most recently (also default initial state)
    var isExactIn = independentField === _types__WEBPACK_IMPORTED_MODULE_16__/* .Field.INPUT */ .g.INPUT;
    // Whether to base calculations on output field
    var isOutputBasis = basisField === _types__WEBPACK_IMPORTED_MODULE_16__/* .Field.OUTPUT */ .g.OUTPUT;
    // Whether user modified the PRICE field most recently
    var isDesiredRateUpdate = independentField === _types__WEBPACK_IMPORTED_MODULE_16__/* .Field.PRICE */ .g.PRICE;
    // Get the amount of outputCurrency you'd receive at the desired price
    var desiredOutputAsCurrencyAmount = isDesiredRateUpdate ? getDesiredOutput(inputValue, typedValue, inputCurrency, outputCurrency, rateType === _types__WEBPACK_IMPORTED_MODULE_16__/* .Rate.DIV */ .j.DIV) : undefined;
    var desiredInputAsCurrencyAmount = isDesiredRateUpdate ? getDesiredInput(outputValue, typedValue, inputCurrency, outputCurrency, rateType === _types__WEBPACK_IMPORTED_MODULE_16__/* .Rate.DIV */ .j.DIV) : undefined;
    // Convert output to string representation to parse later
    var desiredOutputAsString = isDesiredRateUpdate && desiredOutputAsCurrencyAmount ? desiredOutputAsCurrencyAmount === null || desiredOutputAsCurrencyAmount === void 0 ? void 0 : desiredOutputAsCurrencyAmount.toSignificant(6) : typedValue;
    var ref7;
    // If independentField === Field.PRICE -> this won't be used
    var parsedTypedAmount = !isDesiredRateUpdate ? (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(typedValue, (ref7 = isExactIn ? inputCurrency : outputCurrency) !== null && ref7 !== void 0 ? ref7 : undefined) : undefined;
    // If not price - cast input or output typing to CurrencyAmount
    // if price - whatever amount of tokens received on the desired price
    var tradeAmount = isDesiredRateUpdate ? isOutputBasis ? outputAmount : (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(desiredOutputAsString, outputCurrency) : (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(typedValue, isExactIn ? inputCurrency : outputCurrency);
    // Get trade object
    // gonna be null if not isExactIn or if there is no outputCurrency selected
    var bestTradeExactIn = (0,hooks_Trades__WEBPACK_IMPORTED_MODULE_9__/* .useTradeExactIn */ .AU)(isExactIn ? tradeAmount : undefined, outputCurrency);
    // Works similarly to swap when you modify outputCurrency
    // But also is used when desired rate is modified
    // in other words it looks for a trade of inputCurrency for whatever the amount of tokens would be at desired rate
    var bestTradeExactOut = (0,hooks_Trades__WEBPACK_IMPORTED_MODULE_9__/* .useTradeExactOut */ ["in"])(inputCurrency, !isExactIn || isOutputBasis ? tradeAmount : undefined);
    var trade = isExactIn ? bestTradeExactIn : bestTradeExactOut;
    // Get swap price for single token disregarding slippage and price impact
    // needed for chart's latest value
    var oneInputToken = (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("1", currencies.input);
    var singleTokenTrade = (0,hooks_Trades__WEBPACK_IMPORTED_MODULE_9__/* .useTradeExactIn */ .AU)(oneInputToken, currencies.output);
    var singleTokenPrice = parseFloat(singleTokenTrade === null || singleTokenTrade === void 0 ? void 0 : (ref = singleTokenTrade.executionPrice) === null || ref === void 0 ? void 0 : ref.toSignificant(6));
    var inverseSingleTokenPrice = 1 / singleTokenPrice;
    // Get "final" amounts
    var parsedAmounts = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        // Use trade amount as default
        var input = trade === null || trade === void 0 ? void 0 : trade.inputAmount;
        if (!isOutputBasis) {
            // If we're not in output basis mode then we're in input basis mode
            // hence - no matter what keep input as specified by user
            input = inputAmount;
        } else if (independentField === _types__WEBPACK_IMPORTED_MODULE_16__/* .Field.INPUT */ .g.INPUT) {
            // If user touching input field -> whatever they type currently
            input = parsedTypedAmount;
        } else if (isDesiredRateUpdate) {
            // If user modifies the price AND is wishing for specific output amount -> hypothetical input amount at better price
            input = desiredInputAsCurrencyAmount;
        }
        // Use trade amount as default
        // If we're in output basis mode - no matter what keep output as specified by user
        var output;
        if (isOutputBasis) {
            output = outputAmount;
        } else if (independentField === _types__WEBPACK_IMPORTED_MODULE_16__/* .Field.OUTPUT */ .g.OUTPUT) {
            // If user touching input field -> whatever they type currently
            output = parsedTypedAmount;
        } else if (isDesiredRateUpdate) {
            // If user modifies the price AND is wishing for specific input amount -> hypothetical input amount at better price
            output = desiredOutputAsCurrencyAmount;
        } else {
            output = trade === null || trade === void 0 ? void 0 : trade.outputAmount;
        }
        return {
            input: input,
            output: output
        };
    }, [
        independentField,
        parsedTypedAmount,
        inputAmount,
        outputAmount,
        trade,
        isDesiredRateUpdate,
        isOutputBasis,
        desiredInputAsCurrencyAmount,
        desiredOutputAsCurrencyAmount, 
    ]);
    // Calculate the price for specified swap
    var price = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return (0,views_LimitOrders_utils_getPriceForOneToken__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(parsedAmounts.input, parsedAmounts.output);
    }, [
        parsedAmounts.input,
        parsedAmounts.output
    ]);
    var ref8, ref9, ref10, ref11;
    // Formatted amounts to use in the UI
    var formattedAmounts = {
        input: !isOutputBasis && inputValue && inputValue !== "" ? inputValue : (ref8 = (ref1 = parsedAmounts.input) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6)) !== null && ref8 !== void 0 ? ref8 : "",
        output: isOutputBasis && outputValue && outputValue !== "" ? outputValue : (ref9 = (ref2 = parsedAmounts.output) === null || ref2 === void 0 ? void 0 : ref2.toSignificant(6)) !== null && ref9 !== void 0 ? ref9 : "",
        price: independentField === _types__WEBPACK_IMPORTED_MODULE_16__/* .Field.PRICE */ .g.PRICE ? typedValue : rateType === _types__WEBPACK_IMPORTED_MODULE_16__/* .Rate.MUL */ .j.MUL ? (ref10 = price === null || price === void 0 ? void 0 : price.toSignificant(6)) !== null && ref10 !== void 0 ? ref10 : "" : (ref11 = price === null || price === void 0 ? void 0 : price.invert().toSignificant(6)) !== null && ref11 !== void 0 ? ref11 : ""
    };
    // Get raw amounts that will be used in smart contract call
    var rawAmounts = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        var ref, ref1;
        return {
            input: inputCurrency ? (ref = parsedAmounts.input) === null || ref === void 0 ? void 0 : ref.multiply(jsbi__WEBPACK_IMPORTED_MODULE_0___default().exponentiate(config_constants_exchange__WEBPACK_IMPORTED_MODULE_4__/* .BIG_INT_TEN */ .TY, jsbi__WEBPACK_IMPORTED_MODULE_0___default().BigInt(inputCurrency.decimals))).toFixed(0) : undefined,
            output: outputCurrency ? (ref1 = parsedAmounts.output) === null || ref1 === void 0 ? void 0 : ref1.multiply(jsbi__WEBPACK_IMPORTED_MODULE_0___default().exponentiate(config_constants_exchange__WEBPACK_IMPORTED_MODULE_4__/* .BIG_INT_TEN */ .TY, jsbi__WEBPACK_IMPORTED_MODULE_0___default().BigInt(outputCurrency.decimals))).toFixed(0) : undefined
        };
    }, [
        inputCurrency,
        outputCurrency,
        parsedAmounts
    ]);
    var _obj;
    return {
        currencies: currencies,
        currencyBalances: currencyBalances,
        inputError: getErrorMessage(account, wrappedCurrencies, currencies, currencyBalances, parsedAmounts, trade, price, rateType, t),
        formattedAmounts: formattedAmounts,
        trade: trade !== null && trade !== void 0 ? trade : undefined,
        parsedAmounts: parsedAmounts,
        price: price,
        rawAmounts: rawAmounts,
        wrappedCurrencies: wrappedCurrencies,
        singleTokenPrice: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj, (ref3 = wrappedCurrencies.input) === null || ref3 === void 0 ? void 0 : ref3.address, singleTokenPrice), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj, (ref4 = wrappedCurrencies.output) === null || ref4 === void 0 ? void 0 : ref4.address, inverseSingleTokenPrice), _obj),
        currencyIds: {
            input: inputCurrencyId,
            output: outputCurrencyId
        }
    };
};
function parseTokenAmountURLParameter(urlParam) {
    return typeof urlParam === "string" && !Number.isNaN(parseFloat(urlParam)) ? urlParam : "";
}
function parseIndependentFieldURLParameter(urlParam) {
    return typeof urlParam === "string" && urlParam.toLowerCase() === "output" ? _types__WEBPACK_IMPORTED_MODULE_16__/* .Field.OUTPUT */ .g.OUTPUT : _types__WEBPACK_IMPORTED_MODULE_16__/* .Field.INPUT */ .g.INPUT;
}
function parseCurrencyFromURLParameter(urlParam) {
    if (typeof urlParam === "string") {
        var valid = (0,utils__WEBPACK_IMPORTED_MODULE_11__/* .isAddress */ .UJ)(urlParam);
        if (valid) return valid;
        if (urlParam.toUpperCase() === "BNB") return "BNB";
        if (valid === false) return "BNB";
    }
    return "";
}
// TODO: combine with swap's version but use generic type. Same for helpers above
// Note: swap has recipient and other things. Merging these 2 would probably be much easier if we get rid of recipient
// Also the whole thing doesn't make sense, in swap inputValue is not initialized but typedValue is. WTF
var queryParametersToSwapState = function(parsedQs) {
    var inputCurrency = parseCurrencyFromURLParameter(parsedQs.inputCurrency) || config_constants_exchange__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_INPUT_CURRENCY */ .VN;
    var outputCurrency = parseCurrencyFromURLParameter(parsedQs.outputCurrency) || config_constants_exchange__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_OUTPUT_CURRENCY */ .g$;
    if (inputCurrency === outputCurrency) {
        if (typeof parsedQs.outputCurrency === "string") {
            inputCurrency = "";
        } else {
            outputCurrency = "";
        }
    }
    var _obj;
    return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj, _types__WEBPACK_IMPORTED_MODULE_16__/* .Field.INPUT */ .g.INPUT, {
        currencyId: inputCurrency
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj, _types__WEBPACK_IMPORTED_MODULE_16__/* .Field.OUTPUT */ .g.OUTPUT, {
        currencyId: outputCurrency
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj, "inputValue", ""), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj, "outputValue", ""), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj, "typedValue", parseTokenAmountURLParameter(parsedQs.exactAmount)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj, "independentField", parseIndependentFieldURLParameter(parsedQs.exactField)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj, "basisField", parseIndependentFieldURLParameter(parsedQs.exactField)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj, "rateType", _types__WEBPACK_IMPORTED_MODULE_16__/* .Rate.MUL */ .j.MUL), _obj;
};
// updates the swap state to use the defaults for a given network
var useDefaultsFromURLSearch = function() {
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().chainId;
    var dispatch = (0,___WEBPACK_IMPORTED_MODULE_17__/* .useAppDispatch */ .TL)();
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().query;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(), result = ref[0], setResult = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (!chainId) return;
        var parsed = queryParametersToSwapState(query);
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_15__/* .replaceLimitOrdersState */ .sQ)(parsed));
        setResult({
            inputCurrencyId: parsed[_types__WEBPACK_IMPORTED_MODULE_16__/* .Field.INPUT */ .g.INPUT].currencyId,
            outputCurrencyId: parsed[_types__WEBPACK_IMPORTED_MODULE_16__/* .Field.OUTPUT */ .g.OUTPUT].currencyId
        });
    }, [
        dispatch,
        chainId,
        query
    ]);
    return result;
};


/***/ }),

/***/ 11372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ maxAmountSpend; }
/* harmony export */ });
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46472);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56974);


/**
 * Given some token amount, return the max that can be spent of it
 * @param currencyAmount to return max of
 */ function maxAmountSpend(currencyAmount) {
    var ref;
    if (!currencyAmount) return undefined;
    if ((ref = currencyAmount.currency) === null || ref === void 0 ? void 0 : ref.isNative) {
        if (_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.greaterThan */ .QA.greaterThan(currencyAmount.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .MIN_BNB */ .Uz)) {
            return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(currencyAmount.currency, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.subtract */ .QA.subtract(currencyAmount.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .MIN_BNB */ .Uz));
        }
        return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(currencyAmount.currency, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .BIG_INT_ZERO */ .iV);
    }
    return currencyAmount;
}


/***/ }),

/***/ 13629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46472);

/**
 * Given certain amount if input and output tokens
 * calculate the price for 1 input token in terms of output tokens
 */ var getPriceForOneToken = function(inputAmount, outputAmount) {
    if (!inputAmount || !outputAmount || inputAmount.equalTo(0) || outputAmount.equalTo(0)) {
        return undefined;
    }
    return new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Price */ .tA({
        baseAmount: inputAmount,
        quoteAmount: outputAmount
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (getPriceForOneToken);


/***/ }),

/***/ 32288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Chart_PriceChartContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 1 modules
var src = __webpack_require__(68486);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
;// CONCATENATED MODULE: ./src/views/Swap/components/Chart/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  border-radius: 32px;\n  width: 100%;\n  padding-top: 36px;\n\n  ",
        " {\n    padding-top: 8px;\n    background: #12161c;\n    border: 1px solid #292D34;\n    box-shadow: 0px 30px 31px rgba(0, 0, 0, 0.11);\n    backdrop-filter: blur(7.5px);\n    /* Note: backdrop-filter has minimal browser support */\n\n    border-radius: 12px;\n    width: ",
        ";\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledPriceChart = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-67ea7767-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var $isExpanded = param.$isExpanded, $isFullWidthContainer = param.$isFullWidthContainer;
    return $isFullWidthContainer || $isExpanded ? "95%" : "700px";
}, function(param) {
    var $isExpanded = param.$isExpanded;
    return $isExpanded ? "calc(100vh - 100px)" : "516px";
});
StyledPriceChart.defaultProps = {
    height: "70%"
};

;// CONCATENATED MODULE: ./src/views/Swap/components/Chart/BnbWbnbNotice.tsx




var BnbWbnbNotice = function(param) {
    var isDark = param.isDark, isChartExpanded = param.isChartExpanded;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPriceChart, {
        $isDark: isDark,
        $isExpanded: isChartExpanded,
        p: "24px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    mb: [
                        "8px",
                        "8px",
                        "0px"
                    ],
                    textAlign: "center",
                    children: t("You can swap WBNB for BNB (and vice versa) with no trading fees.")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    mb: [
                        "8px",
                        "8px",
                        "0px"
                    ],
                    textAlign: "center",
                    children: t("Exchange rate is always 1 to 1.")
                })
            ]
        })
    });
};
/* harmony default export */ var Chart_BnbWbnbNotice = (BnbWbnbNotice);

// EXTERNAL MODULE: ./src/views/Swap/components/Chart/constants.ts
var constants = __webpack_require__(96588);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(89663);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/SyncAlt.tsx
var SyncAlt = __webpack_require__(20363);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Shrink.tsx
var Shrink = __webpack_require__(68187);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Expand.tsx
var Expand = __webpack_require__(70112);
// EXTERNAL MODULE: ./src/components/Logo/index.ts + 2 modules
var Logo = __webpack_require__(19259);
// EXTERNAL MODULE: ./src/state/user/actions.ts
var actions = __webpack_require__(9372);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var hooks = __webpack_require__(921);
// EXTERNAL MODULE: ./src/state/swap/hooks.ts + 13 modules
var swap_hooks = __webpack_require__(47455);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/views/Swap/components/Chart/NoChartAvailable.tsx



var NoChartAvailable = function(param) {
    var token0Address = param.token0Address, token1Address = param.token1Address, pairAddress = param.pairAddress, isMobile = param.isMobile;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    mb: [
                        "8px",
                        "8px",
                        "0px"
                    ],
                    children: t("Failed to load price chart for this pair")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    textAlign: isMobile ? "center" : "left",
                    mb: [
                        "8px",
                        "8px",
                        "0px"
                    ],
                    color: "textSubtle",
                    small: true,
                    style: isMobile && {
                        wordSpacing: "100vw"
                    },
                    children: [
                        "Token0: ",
                        token0Address !== null && token0Address !== void 0 ? token0Address : "null"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    textAlign: isMobile ? "center" : "left",
                    mb: [
                        "8px",
                        "8px",
                        "0px"
                    ],
                    color: "textSubtle",
                    small: true,
                    style: isMobile && {
                        wordSpacing: "100vw"
                    },
                    children: [
                        "Token1: ",
                        token1Address !== null && token1Address !== void 0 ? token1Address : "null"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    textAlign: isMobile ? "center" : "left",
                    mb: [
                        "8px",
                        "8px",
                        "0px"
                    ],
                    color: "textSubtle",
                    small: true,
                    style: isMobile && {
                        wordSpacing: "100vw"
                    },
                    children: [
                        "Pair: ",
                        pairAddress !== null && pairAddress !== void 0 ? pairAddress : "null"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Chart_NoChartAvailable = (NoChartAvailable);

// EXTERNAL MODULE: ./src/components/PairPriceDisplay.tsx
var PairPriceDisplay = __webpack_require__(78147);
// EXTERNAL MODULE: ./src/views/Swap/components/Chart/utils.ts
var utils = __webpack_require__(22713);
;// CONCATENATED MODULE: ./src/views/Swap/components/Chart/BasicChart.tsx
/* eslint-disable @typescript-eslint/no-unused-vars */ 









var SwapLineChart = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9782), __webpack_require__.e(265), __webpack_require__.e(6354)]).then(__webpack_require__.bind(__webpack_require__, 78084));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78084)
            ];
        }
    },
    ssr: false
});
var BasicChart = function(param) {
    var token0Address = param.token0Address, token1Address = param.token1Address, isChartExpanded = param.isChartExpanded, inputCurrency = param.inputCurrency, outputCurrency = param.outputCurrency, isMobile = param.isMobile, currentSwapPrice = param.currentSwapPrice;
    var ref;
    var ref1 = (0,react.useState)(0), timeWindow = ref1[0], setTimeWindow = ref1[1];
    var ref2 = (0,swap_hooks/* useFetchPairPrices */.rH)({
        token0Address: token0Address,
        token1Address: token1Address,
        timeWindow: timeWindow,
        currentSwapPrice: currentSwapPrice
    }), _pairPrices = ref2.pairPrices, pairPrices = _pairPrices === void 0 ? [] : _pairPrices, pairId = ref2.pairId;
    var ref3 = (0,react.useState)(), hoverValue = ref3[0], setHoverValue = ref3[1];
    var ref4 = (0,react.useState)(), hoverDate = ref4[0], setHoverDate = ref4[1];
    // const pairChartPrices = pairPrices.pop()
    var valueToDisplay = hoverValue || ((ref = pairPrices[pairPrices.length - 1]) === null || ref === void 0 ? void 0 : ref.value);
    var ref5 = (0,utils/* getTimeWindowChange */.E)(pairPrices), changePercentage = ref5.changePercentage, changeValue = ref5.changeValue;
    var isChangePositive = changeValue >= 0;
    var chartHeight = isChartExpanded ? "calc(100% - 120px)" : "378px";
    var ref6 = (0,src/* useTranslation */.$G)(), t = ref6.t, locale = ref6.currentLanguage.locale;
    var currentDate = new Date().toLocaleString(locale, {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    });
    // Sometimes we might receive array full of zeros for obscure tokens while trying to derive data
    // In that case chart is not useful to users
    var isBadData = pairPrices && pairPrices.length > 0 && pairPrices.every(function(price) {
        return !price.value || price.value === 0 || price.value === Infinity || Number.isNaN(price.value);
    });
    console.log("pairPrices===", pairPrices);
    // console.log('pairChartPrices===', pairChartPrices)
    if (isBadData) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_NoChartAvailable, {
            token0Address: token0Address,
            token1Address: token1Address,
            pairAddress: pairId,
            isMobile: isMobile
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                flexDirection: [
                    "column",
                    null,
                    null,
                    null,
                    null,
                    null,
                    "row"
                ],
                alignItems: [
                    "flex-start",
                    null,
                    null,
                    null,
                    null,
                    null,
                    "center"
                ],
                justifyContent: "space-between",
                px: "24px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    flexDirection: "column",
                    mb: "45px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PairPriceDisplay/* default */.Z, {
                            value: (pairPrices === null || pairPrices === void 0 ? void 0 : pairPrices.length) > 0 && valueToDisplay,
                            inputSymbol: inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.symbol,
                            outputSymbol: outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.symbol,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: isChangePositive ? "success" : "failure",
                                fontSize: "20px",
                                ml: "4px",
                                bold: true,
                                children: "".concat(isChangePositive ? "+" : "").concat(changeValue.toFixed(3), " (").concat(changePercentage, "%)")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            small: true,
                            color: "secondary",
                            children: hoverDate || currentDate
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                height: isMobile ? "100%" : chartHeight,
                p: isMobile ? "0px" : "16px",
                width: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapLineChart, {
                    data: pairPrices,
                    setHoverValue: setHoverValue,
                    setHoverDate: setHoverDate,
                    isChangePositive: isChangePositive,
                    timeWindow: timeWindow
                })
            })
        ]
    });
};
/* harmony default export */ var Chart_BasicChart = (/*#__PURE__*/(0,react.memo)(BasicChart, function(prev, next) {
    return prev.token0Address === next.token0Address && prev.token1Address === next.token1Address && prev.isChartExpanded === next.isChartExpanded && prev.isMobile === next.isMobile && prev.isChartExpanded === next.isChartExpanded && (prev.currentSwapPrice !== null && next.currentSwapPrice !== null && prev.currentSwapPrice[prev.token0Address] === next.currentSwapPrice[next.token0Address] && prev.currentSwapPrice[prev.token1Address] === next.currentSwapPrice[next.token1Address] || prev.currentSwapPrice === null && next.currentSwapPrice === null);
}));

;// CONCATENATED MODULE: ./src/views/Swap/components/Chart/PriceChart.tsx





// import { TradingViewLabel } from 'components/TradingView'
// import { useTranslation } from '@pancakeswap/localization'


// import styled from 'styled-components'


// import TradingViewChart from './TradingViewChart'
// import PairPriceDisplay from '../../../../components/PairPriceDisplay'
// const ChartButton = styled(Button)`
//   background-color: ${({ $active, theme }) => $active && `${theme.colors.primary}0f`};
//   padding: 4px 8px;
//   border-radius: 6px;
// `
var PriceChart = function(param) {
    var inputCurrency = param.inputCurrency, outputCurrency = param.outputCurrency, onSwitchTokens = param.onSwitchTokens, isDark = param.isDark, isChartExpanded = param.isChartExpanded, setIsChartExpanded = param.setIsChartExpanded, isMobile = param.isMobile, isFullWidthContainer = param.isFullWidthContainer, token0Address = param.token0Address, token1Address = param.token1Address, currentSwapPrice = param.currentSwapPrice;
    // const { isDesktop } = useMatchBreakpoints()
    var toggleExpanded = function() {
        return setIsChartExpanded(function(currentIsExpanded) {
            return !currentIsExpanded;
        });
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useExchangeChartViewManager */.OE)(), 1), chartView = ref[0];
    // const [chartView, setChartView] = useExchangeChartViewManager()
    // const [twChartSymbol, setTwChartSymbol] = useState('')
    // const { t } = useTranslation()
    // const handleTwChartSymbol = useCallback((symbol) => {
    //   setTwChartSymbol(symbol)
    // }, [])
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPriceChart, {
        height: chartView === actions/* ChartViewMode.TRADING_VIEW */.UU.TRADING_VIEW ? "100%" : "70%",
        overflow: chartView === actions/* ChartViewMode.TRADING_VIEW */.UU.TRADING_VIEW ? "hidden" : "unset",
        $isDark: isDark,
        $isExpanded: isChartExpanded,
        $isFullWidthContainer: isFullWidthContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                justifyContent: "space-between",
                px: "24px",
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                        alignItems: "center",
                        position: "absolute",
                        right: "0",
                        top: "10px",
                        mx: 4,
                        children: [
                            outputCurrency ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* DoubleCurrencyLogo */.ge, {
                                currency0: inputCurrency,
                                currency1: outputCurrency,
                                size: 24
                            }) : inputCurrency && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                currency: inputCurrency,
                                size: "24px",
                                style: {
                                    marginRight: "8px"
                                }
                            }),
                            inputCurrency && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "text",
                                bold: true,
                                children: outputCurrency ? "".concat(inputCurrency.symbol, "/").concat(outputCurrency.symbol) : inputCurrency.symbol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                variant: "text",
                                onClick: onSwitchTokens,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SyncAlt/* default */.Z, {
                                    ml: "6px",
                                    color: "text"
                                })
                            })
                        ]
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                        visibility: "hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            variant: "text",
                            onClick: toggleExpanded,
                            children: isChartExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Shrink/* default */.Z, {
                                color: "text"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Expand/* default */.Z, {
                                color: "text"
                            })
                        })
                    })
                ]
            }),
            chartView === actions/* ChartViewMode.BASIC */.UU.BASIC && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_BasicChart, {
                token0Address: token0Address,
                token1Address: token1Address,
                isChartExpanded: isChartExpanded,
                inputCurrency: inputCurrency,
                outputCurrency: outputCurrency,
                isMobile: isMobile,
                currentSwapPrice: currentSwapPrice
            })
        ]
    });
};
/* harmony default export */ var Chart_PriceChart = (PriceChart);

;// CONCATENATED MODULE: ./src/views/Swap/components/Chart/PriceChartContainer.tsx







var PriceChartContainer = function(param) {
    var inputCurrencyId = param.inputCurrencyId, inputCurrency = param.inputCurrency, outputCurrency = param.outputCurrency, outputCurrencyId = param.outputCurrencyId, isChartExpanded = param.isChartExpanded, setIsChartExpanded = param.setIsChartExpanded, isChartDisplayed = param.isChartDisplayed, isMobile = param.isMobile, _isFullWidthContainer = param.isFullWidthContainer, isFullWidthContainer = _isFullWidthContainer === void 0 ? false : _isFullWidthContainer, currentSwapPrice = param.currentSwapPrice;
    var token0Address = (0,utils/* getTokenAddress */.D)(inputCurrencyId);
    var token1Address = (0,utils/* getTokenAddress */.D)(outputCurrencyId);
    var ref = (0,react.useState)(false), isPairReversed = ref[0], setIsPairReversed = ref[1];
    var togglePairReversed = (0,react.useCallback)(function() {
        return setIsPairReversed(function(prePairReversed) {
            return !prePairReversed;
        });
    }, []);
    var isDark = (0,useTheme/* default */.ZP)().isDark;
    if (!isChartDisplayed) {
        return null;
    }
    var isBnbWbnb = token0Address === constants/* BNB_ADDRESS */.I && token1Address === constants/* BNB_ADDRESS */.I;
    if (isBnbWbnb) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_BnbWbnbNotice, {
            isDark: isDark,
            isChartExpanded: isChartExpanded
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_PriceChart, {
        token0Address: isPairReversed ? token1Address : token0Address,
        token1Address: isPairReversed ? token0Address : token1Address,
        inputCurrency: isPairReversed ? outputCurrency : inputCurrency,
        outputCurrency: isPairReversed ? inputCurrency : outputCurrency,
        onSwitchTokens: togglePairReversed,
        isDark: isDark,
        isChartExpanded: isChartExpanded,
        setIsChartExpanded: setIsChartExpanded,
        isMobile: isMobile,
        isFullWidthContainer: isFullWidthContainer,
        currentSwapPrice: currentSwapPrice
    });
};
/* harmony default export */ var Chart_PriceChartContainer = (PriceChartContainer);


/***/ })

}]);